var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.Config.environment,attrs:{"id":"app"}},[(!_vm.loading)?[(_vm.init || _vm.$route.meta.public)?[(_vm.User && _vm.User.security_level == 0)?_c('Password'):[_c('keep-alive',[_c('router-view')],1)]]:_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }